import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const ShirtManufacturingShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="Shirt Manufacturing Section"
    sectionKey="Shirt Manufacturing"
    backRoute="/sections/shirt-manufacturing"
  />
);

export default ShirtManufacturingShipmentRequest;
